module.exports = __webpack_public_path__ + "static/media/cover-image-economist.99e2e4d9.jpg";